module.exports = __webpack_public_path__ + "static/media/bone.fbfe4c77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/bone.svg
// module id = 367
// module chunks = 0